import { Button, Dialog, Icon, Pagination, Tab, Table, Tree } from "@alifd/next";
import { BefGlobalContext, BefMenuServiceContext, BefMessageButtonType, BefMessageServiceContext, BefMessageType, BefRpcContext, IBefMenuElement } from "@beflam/bef-core";
import EventEmitter from "events";
import { set } from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import menuRefresh from "./menuRefresh";
import exp from "constants";
export class AllFunctionsProps {
    data: any;
    onOK: any | undefined;
}
export function AllFunctions(props: AllFunctionsProps) {
    const befRpc = useContext(BefRpcContext);
    const messageService = useContext(BefMessageServiceContext);
    const menu = useContext(BefMenuServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const [menuData, setMenuData] = useState<any>([]);
    const [defaultActiveKey, setDefaultActiveKey] = useState("");
    const refresh = async (_isShow: boolean = false) => {
        try {
            let _data = [] as any;
            if (props.data.length > 0) {
                setDefaultActiveKey(props.data[0].ID);
                _data = props.data;
            }

            setMenuData(_data);

            // menu.getMenuGroups().subscribe((result: any) => {
            //     if (result) {
            //         let _datas: any[] = [];
            //         result.map((res: any) => {
            //             if (res) {
            //                 let temp = res.Groups.filter((item: any) => item.ID !== "__starMenuGroup");
            //                 _datas = _datas.concat(temp);
            //             }
            //         });
            //         if (_datas.length > 0) {
            //             setDefaultActiveKey(_datas[0].ID);
            //         }
            //         setMenuData(_datas);
            //     };

            // });

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "菜单获取"));
        }
    }

    const onTabChange = (key: any) => {
        // if (key == 2) {
        //     refreshType();
        // }
    }
    const If = (props: { condition: boolean; then: any; else: any; }) => {
        const condition = props.condition || false;
        const positive = props.then || null;
        const negative = props.else || null;

        return condition ? positive : negative;
    };
    const getSubMenuItemTem = (item: IBefMenuElement) => {
        return (<>
            <If condition={!item.Items || item.Items.length === 0}
                then={<div className="menu-card-div"> <div className="menu-card">
                    <If condition={!item.Icon} then={<i className='default-i glyphicon glyphicon-th-large' />} else={getIconControl(item.Icon)}></If>
                    {/* <img src={item.Icon} /> */}
                    <div className="menu-card-right" >
                        <div onClick={() => onMenuItemClick(item)}>
                            <p title={item.Text}>{item.Text}</p>
                            <p className="sub" title={item.ID}>{item.ID}</p>
                        </div>
                        {getStarIcon(item)}

                    </div>
                </div></div>
                }

                else={null}></If>
            <If condition={(item.Items?.length ?? 0) > 0}
                then={<>{item.Items?.map((item2: IBefMenuElement) => getSubMenuItemTem(item2))}</>}
                else={null} />
        </>

        );
    };
    const getMenuItemTem = (item: IBefMenuElement) => {
        return (<>
            <If condition={!item.Items || item.Items.length === 0}
                then={
                    <div className="menu-card-div">
                        <div className="menu-card">
                            <If condition={!item.Icon} then={<i className='default-i glyphicon glyphicon-th-large' />} else={getIconControl(item.Icon)}></If>
                            {/* <img src={item.Icon} /> */}
                            <div className="menu-card-right" >
                                <div onClick={() => onMenuItemClick(item)}>
                                    <p title={item.Text}>{item.Text}</p>
                                    <p className="sub" title={item.ID}>{item.ID}</p>
                                </div>
                                {getStarIcon(item)}

                            </div>
                        </div></div>
                }

                else={null}></If>
            <If condition={(item.Items?.length ?? 0) > 0}
                then={<>
                    <div className="menu-sub-div"><div><p>{item.Text}</p></div><div className="menu-con">
                        {item.Items?.map((item2: IBefMenuElement) => getSubMenuItemTem(item2))}
                    </div> <div className="line">
                        </div>
                    </div></>}
                else={null} />
        </>

        );
    };
    const getIconControl = (icon: string) => {
        if (icon) {
            if (icon.split('/').length > 1) {
                return <img alt="image" src={icon} />;
            } else {
                return <i className={icon} aria-hidden="true" style={{ marginRight: '6px' }}></i>;
            }
        }
        return null;
    }
    const starMenu = async (item: IBefMenuElement, event?: any) => {
        event?.stopPropagation();
        var result = await menu.starMenu(item.ID, !item.IsStarred);
      //  refresh();
        menuRefresh.emit("refreshMenu", { isRefresh: true, data: result });
    }
    const getStarIcon = (item: IBefMenuElement) => {
        if (item && !item.IsStarMenu)
            return <span className={'arrow glyphicon ' + (item.IsStarred ? 'glyphicon-star bef-menu-star-active' : 'glyphicon-star-empty')} onClick={starMenu.bind(null, item)}></ span>
        else
            return null;
    }
    //点击菜单
    const onMenuItemClick = (_menu: IBefMenuElement, _moduleId?: string) => {
        // menu.openMenu(_menu, _moduleId);
        const currentUrl = `/?appid=${sGlobal.currentAppId}&moduleid=${_menu.ModuleId}&menuid=${_menu.ID}`;
        window.open(currentUrl);
        if (props.onOK)
            props.onOK();
    }

    useEffect(() => {
        refresh();
    }, [props.data]);
    return (
        <>
            <div className=" bef-custom-fun bef-fun">
                {/* <div className="bef-fun-header">
                    <span className="bef-fun-title">全部功能</span>
                </div> */}
                <div className="bef-fun-main">
                    <div className="tab-div">
                        <Tab onChange={onTabChange} unmountInactiveTabs defaultActiveKey="0" excessMode="slide">
                            {menuData && menuData.length > 0 && menuData.map((item: any, index: any) => {
                                return <Tab.Item title={item.Text} key={index}>
                                    <div className="menu-con-scroll">
                                        <div className="menu-con tab-item">
                                            <If condition={!item.Items || item.Items.length === 0}
                                                then={
                                                    <div className="menu-card-div">
                                                        <div className="menu-card" >
                                                            {/* <img src={item.Icon} />     */}
                                                            <If condition={!item.Icon} then={<i className='default-i glyphicon glyphicon-th-large' />} else={getIconControl(item.Icon)}></If>
                                                            <div className="menu-card-right" >
                                                                <div onClick={() => onMenuItemClick(item)}>
                                                                    <p title={item.Text}>{item.Text}</p>
                                                                    <p className="sub" title={item.ID}>{item.ID}</p>
                                                                </div>
                                                                {getStarIcon(item)}
                                                            </div>
                                                        </div>

                                                    </div>
                                                }

                                                else={null}></If>
                                            <If condition={(item.Items?.length ?? 0) > 0}
                                                then={
                                                    <>{item.Items?.map((item2: IBefMenuElement) => getMenuItemTem(item2))}</>}
                                                else={null} />
                                        </div>
                                    </div>
                                </Tab.Item>
                            })

                            }
                        </Tab>
                    </div>
                </div>

            </div>
        </>
    );
}